import React from "react";
import PropTypes from "prop-types";
import CopyLink from "@/components/SocialShare/CopyLink";
import SocialLink from "@/components/SocialShare/SocialLink";
import { Twitter, Facebook } from "@/icons";

const DesktopShare = ({ url, encodedUrl }) => {
  const SOCIALS = [
    {
      href: "https://www.facebook.com/sharer/sharer.php?u=",
      icon: Facebook
    },
    {
      href: "https://www.twitter.com/share?url=",
      icon: Twitter
    }
  ];

  return (
    <>
      {SOCIALS.map(({ href, icon: Icon }, id) => (
        <SocialLink link={href} key={id} encodedUrl={encodedUrl}>
          <Icon />
        </SocialLink>
      ))}
      <CopyLink url={url} />
    </>
  );
};

export default DesktopShare;

DesktopShare.propTypes = {
  url: PropTypes.string,
  encodedUrl: PropTypes.string
};
